<template>
  <div  v-if="reference && !editable"
        class="flex-1">

    <label class="text-xs lg:hidden text-gray-900 uppercase truncate pl-1">Rate</label>
    <div  class="relative w-full lg:h-full flex flex-col justify-center"
          :class="{ 'bg-gray-200': reference || !editable }">

      <span class="absolute pl-1 text-gray-500 pointer-events-none">{{ settings.currency }}</span>
      <input class="w-full p-1 lg:pl-4 lg:pr-2 align-middle text-right bg-gray-200 cursor-default"
             v-model.number="rate"
             :disabled="disabled"
             :class="{ 'line-through' : !active }"
             @click.stop.prevent="editReference" />
    </div>
  </div>
  <div  v-else
        class="flex-1">
    <label class="text-xs lg:hidden text-gray-600 uppercase truncate">Rate</label>
    <div class="relative w-full lg:h-full flex flex-col justify-center">
      <span class="absolute pl-1 text-gray-500 pointer-events-none">{{ settings.currency }}</span>
      <input class="w-full p-1 lg:pl-4 lg:pr-2 align-middle text-right bg-white"
             :class="{ 'cursor-default bg-gray-200' : disabled, 'line-through' : !active }"
             :disabled="disabled"
             v-model.number="rate" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowRate',
  props: {
    model: Object,
    settings: Object,
    currency: String,
    uom: Object,
    value: [Number, String],
    disabled: {
      type: Boolean,
      default: false
    },
    reference: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    active: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    rate: {
      get() {
        return this.value || 0
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
  },
  methods: {
    editReference(){
      if(!this.editable){
        this.$emit('edit-reference')
      }
    }
  }
};
</script>
